import { FeatureFlag, useFlags } from '@neo.tax/shared/third-parties';
import { getPath, Path } from '@neo.tax/shared/utils';

import { Loader, RedirectState } from './Loader';

export const LaunchDarklyLoader = ({
  children,
  flagKey,
  useRedirect,
}: {
  children: React.ReactNode;
  flagKey: FeatureFlag;
  useRedirect?: () => RedirectState;
}): React.ReactElement => {
  const flags = useFlags();
  const flag = flags[flagKey];
  return (
    <Loader
      useRedirect={(): RedirectState => {
        if (flag === undefined) return { isLoading: true };
        if (!flag) return { isLoading: false, redirectTo: getPath({ path: Path.LOGIN }) };
        if (!useRedirect) return { isLoading: false };
        // Loader calls this as a hook, which the linter cannot see from here.
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        return useRedirect();
      }}
    >
      {children}
    </Loader>
  );
};
